export default function ({ store }) {
  // This action should run on client side only on router hook
  // it will just check the domain prefix and store it in vuex
  if (process.client) {
    store.dispatch('detected-country/setCurrentDomainPrefix');
  }
}
